import dayjs from "dayjs";

/**
 * Возвращает initial values формы на основе шаблона.
 * Чистая функция: не содержит побочных эффектов.
 */
export const getTemplateInitialValues = (
  templateInput,
  { defaultUnit, defaultStatus, defaultPriority, todayDate, units = [] }
) => {
  const template = templateInput || {};
  const hasTemplateUnit = units.some(({ uuid }) => uuid === template.unit_uuid);
  const unitUuid = template.uuid
    ? template.unit_uuid
      ? hasTemplateUnit
        ? template.unit_uuid
        : null
      : defaultUnit?.uuid
    : defaultUnit?.uuid;

  return {
    template_uuid: template.uuid || null,
    name: template.name || "",
    description: template.description || "",
    unit_uuid: unitUuid,
    start_date: template.uuid
      ? template.start_date
        ? dayjs(template.start_date)
        : todayDate
      : todayDate,
    due_date: template.due_date ? dayjs(template.due_date) : null,
    // новая задача всегда стартует не как черновик
    status_uuid: defaultStatus.uuid,
    importance_uuid: template.uuid
      ? template.importance_uuid || defaultPriority.uuid
      : defaultPriority.uuid,
    responsible_executor_uuid: template.responsible_executor_uuid || null,
    coexecutors_uuids: template.coexecutors
      ? template.coexecutors.map((i) => i.uuid)
      : [],
    assignee_acceptor_uuid: template.assignee_acceptor_uuid || null,
    is_accessible_for_all_in_unit:
      template.is_accessible_for_all_in_unit || false,
    parent_task_uuid: template.parent_task_uuid || null,
    //planned_costs все еще есть у шаблона на случай, если ситуация изменится
    planned_costs: null,
    require_actuals_on_acceptance: template.require_actuals_on_acceptance || false,
  };
};

/**
 * Хук-обёртка для применения шаблона к форме задачи.
 * Внутри вызывает чистую getTemplateInitialValues и выполняет необходимые побочные эффекты.
 */
export const useTaskTemplate = ({
  form,
  user,
  fetchUserList,
  fetchRepeatRules,
  fetchLaborCostsRules,
  onSetIsExecutor,
  onSetIsAcceptor,
  defaults,
}) => {
  const applyTemplate = (item) => {
    const values = getTemplateInitialValues(item, defaults);

    // заполняем форму значениями из шаблона
    form.setFieldsValue(values);

    // если unit изменился — обновим списки участников
    if (values.unit_uuid) {
      fetchUserList(values.unit_uuid);
    }

    // выставляем локальные флаги исполнителя/приёмщика
    const isExec = values.responsible_executor_uuid === user?.employee_uuid;
    const isAcc = values.assignee_acceptor_uuid === user?.employee_uuid;
    onSetIsExecutor && onSetIsExecutor(isExec);
    onSetIsAcceptor && onSetIsAcceptor(isAcc);

    // если шаблон с повторением — загружаем правила
    if (item?.is_recurring_template) {
      fetchRepeatRules(item.uuid);
    }

    fetchLaborCostsRules({ planned_costs: null, require_actuals_on_acceptance: item?.require_actuals_on_acceptance || false });
  };

  return { applyTemplate };
};
